export const Error = "Error";

export const INSERT_CLIENT = "INSERT_CLIENT";
export const GET_CLIENT = "GET_CLIENT";

export const InsertAgencyType = "InsertAgencyType";
export const EditAgencyType = "EditAgencyType";
export const DELETEAgencyType = "DELETEAgencyType";
export const GetAgencyType = "GetAgencyType";

export const InsertAgencyStatus = "InsertAgencyStatus";
export const EditAgencyStatus = "EditAgencyStatus";
export const GetAgencyStatus = "GetAgencyStatus";
export const DELETEAgencyStatus = "DELETEAgencyStatus";

export const InsertAgencyDestination = "InsertAgencyDestination";
export const EditAgencyDestination = "EditAgencyDestination";
export const GetAgencyDestination = "GetAgencyDestination";
export const DeleteAgencyDestination = "DeleteAgencyDestination";

export const InsertAgency = "InsertAgency";
export const GetAgency = "GetAgency";
export const UPDATEAgency = "UPDATEAgency";
export const DELETEAgency = "DELETEAgency";

export const CREATE_NEW_USER = "CREATE_NEW_USER";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const VERIFY_PASSWORD = "VERIFY_PASSWORD";
export const FOREGT_PASSWORD = "FOREGT_PASSWORD";
export const LOGIN_USER = "LOGIN_USER";
export const GET_CURERNT_USER = "GET_CURERNT_USER";
export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const UPDATE_USER_PASSWORD = "UPDATE_USER_PASSWORD";

export const GetAllFiles = "GetAllFiles";
export const GetOneFile = "GetOneFile";
export const DeleteOneFile = "DeleteOneFile";
export const InsertOneFile = "InsertOneFile";
export const UpdateOneFile = "UpdateOneFile";
export const GetAllFilesDetails = "GetAllFilesDetails";
export const GetOneFileDetails = "GetOneFileDetails";
export const DeleteOneFileDetails = "DeleteOneFileDetails";
export const InsertOneFileDetails = "InsertOneFileDetails";
export const UpdateOneFileDetails = "UpdateOneFileDetails";
export const GetOneSupAccountWithMain = "GetOneSupAccountWithMain";
export const DeleteOneSupAccount = "DeleteOneSupAccount";
export const InsertOneSupAccount = "InsertOneSupAccount";
export const UpdateOneSupAccount = "UpdateOneSupAccount";
export const GetAllSubuserAccount = "GetAllSubuserAccount";
export const GetOneSubuserAccount = "GetOneSubuserAccount";
export const DeleteSubuserAccount = "DeleteSubuserAccount";
export const InsertOneSubuserAccount = "InsertOneSubuserAccount";
export const UpdateOneSubuserAccount = "UpdateOneSubuserAccount";
export const GetSubUsersFiles = "GetSubUsersFiles";
export const Insertusersubdash = "Insertusersubdash";
export const Getusersubdash = "Getusersubdash";
export const Insertusersubdashside = "Insertusersubdashside";
export const Getusersubside = "Getusersubside";
export const Insertemailtry = "Insertemailtry";
export const UpdateUserdashboard = "UpdateUserdashboard";
export const UpdateUserAndsubdashboard = "UpdateUserAndsubdashboard";
export const DeleteUserdashboard = "DeleteUserdashboard";
export const GetAllFilesDetailsmulit = "GetAllFilesDetailsmulit";
export const GetAllMainfileAccount = "GetAllMainfileAccount";
export const getFilesubuser = "getFilesubuser";
export const CreateContact = "CreateContact";
export const UpdateQoute = "UpdateQoute";
export const GetQoutsdashh = "GetQoutsdashh";
export const GetQoutssidee = "GetQoutssidee";
export const senEmailtouser = "senEmailtouser";
export const getUserAndSubuser = "getUserAndSubuser";
export const getUserSubscriber = "getUserSubscriber";
export const getFilesDetailsLast = "getFilesDetailsLast";
export const Updateuserdashside = "Updateuserdashside";
export const CreatedashNotification = "CreatedashNotification";
export const getuserNotification = "getuserNotification";
export const DeleteUsersubscripedashboard = "DeleteUsersubscripedashboard";
export const Updatesqouteuserr = "Updatesqouteuserr";
export const notnumber = "notnumber";
export const ADDCOURT = "ADDCOURT";
export const COURT = "COURT";
export const DELETECOURT = "DELETECOURT";
export const UPDATECOURT = "UPDATECOURT";

export const ADDLOCTYPE = "ADDLOCTYPE";
export const UPDATELOCTYPE = "UPDATELOCTYPE";
export const DELETELOCTYPE = "DELETELOCTYPE";
export const LOCTYPE = "LOCTYPE";
export const ADDLOCNUMBER = "ADDLOCNUMBER";
export const UPDATELOCNUMBER = "UPDATELOCNUMBER";
export const DELETELOCNUMBER = "DELETELOCNUMBER";
export const LOCNUMBER = "LOCNUMBER";
export const TYPEDAWA = "TYPEDAWA";
export const ADDTYPEDAWA = "ADDTYPEDAWA";
export const UPDATETYPEDAWA = "UPDATETYPEDAWA";
export const DELETETYPEDAWA = "DELETETYPEDAWA";

export const INSERT_CLIENT_TYPE = "INSERT_CLIENT_TYPE";

export const GET_CLIENT_TYPE = "GET_CLIENT_TYPE";
export const ADD_TAGADEDEFREE = "ADD_TAGADEDEFREE";
export const TAKADEDEGREE = "TAKADEDEGREE";
export const UPDATETAKADEDEGREE = "UPDATETAKADEDEGREE";
export const DELETETAKADEDEGREE = "DELETETAKADEDEGREE";

export const INSERDAWA = "INSERDAWA";
export const GETDAWA = "GETDAWA";
export const DELETEDAWA = "DELETEDAWA";
export const UPDATEDAWA = "UPDATEDAWA";
export const GET_CLIENT_KES = "GET_CLIENT_KES";
export const GET_CLIENT_MO = "GET_CLIENT_MO";
export const GET_CLIENT_TYPE_KESM = "GET_CLIENT_TYPE_KESM";
export const GET_CLIENT_TYPE_MO = "GET_CLIENT_TYPE_MO";
export const DELETE_CLIENT_KES = "DELETE_CLIENT_KES";
export const DELETE_CLIENT_MO = "DELETE_CLIENT_MO";
export const DELETE_CLIENT_TYPE = "DELETE_CLIENT_TYPE";
export const UPDATE_CLIENT_KES = "UPDATE_CLIENT_KES";
export const UPDATE_CLIENT_MO = "UPDATE_CLIENT_MO";
export const UPDATE_CLIENT_TYPE = "UPDATE_CLIENT_TYPE";
export const GETDAWAID = "GETDAWAID";
export const GETAJINDA = "GETAJINDA";
export const INSERTAGENDA = "INSERTAGENDA";
export const UPDATEAJINDA = "UPDATEAJINDA";
export const DELETEAJINDA = "DELETEAJINDA";
export const ADD_MANAGE_WORK = "ADD_MANAGE_WORK";
export const DELETE_MANAGE_WORK = "DELETE_MANAGE_WORK";
export const UPDATE_MANAGE_WORK = "UPDATE_MANAGE_WORK";
export const GET_MANAGE_WORK = "GET_MANAGE_WORK";
export const Create_CONTACT = "Create_CONTACT";


//admin
export const GetRoles = "GetRoles";
export const GetClaims = "GetClaims";
export const CreateUserDashboard = "CreateUserDashboard";
export const ManageUserClaims = "ManageUserClaims";
export const GetUsers = "GetUsers";
